<form #form="ngForm">
  <div *ngIf="mutableObjective" [ngClass]="mutableObjective?.objectiveId > 0 ? 'col' : 'col'">
    <div class="row g-3">
      <!-- name -->
      <div class="col-md-6">
        <label for="objectiveName" class="form-label">{{ 'name' | label : 'general' | async }} *</label>
        <input #name="ngModel" type="text" name="objectiveName" id="objectiveName" class="form-control" [(ngModel)]="mutableObjective.name" required />
      </div>
      <!-- status -->
      <div class="col-md-6">
        <label for="status" class="form-label">{{ 'status' | label : 'general' | async }} *</label>
        <select name="status" id="status" class="form-select" [(ngModel)]="mutableObjective.status" required>
          <option *ngFor="let status of objectiveSingleton.statusses" [ngValue]="status.value">{{ status.name }}</option>
        </select>
      </div>
      <!-- type -->
      <div class="col-md-6" *ngIf="objectiveSingleton.settings.allowTeamGoals">
        <label for="objectiveTypeId" class="form-label">{{ 'type' | label : 'goals' | async }} *</label>
        <select name="objectiveTypeId" id="objectiveTypeId" class="form-select" [required]="objectiveSingleton.settings.allowTeamGoals" [(ngModel)]="mutableObjective.typeId">
          <option *ngFor="let type of objectiveSingleton.types" [ngValue]="type.id">{{ type.name }}</option>
        </select>
      </div>
      <!-- Category -->
      <div class="col-md-6" *ngIf="objectiveSingleton.settings.allowCategories">
        <label for="objectiveCategory" class="form-label"> {{ 'category' | label : 'general' | async }} * </label>
        <select #categorySelect="ngModel" name="objectiveCategoryId" id="objectiveCategory" class="form-select" [required]="objectiveSingleton.settings.allowCategories" [(ngModel)]="mutableObjective.categoryId" (ngModelChange)="categoryValidator(categorySelect.control, mutableObjective); weightValidator(form.controls['weight'], mutableObjective)">
          <option *ngFor="let category of objectiveSingleton.categories" [ngValue]="category.id">
            {{ category.name }}
          </option>
        </select>
        {{ categoryValidator(categorySelect.control, mutableObjective) }}
        <div class="text-danger" *ngIf="categorySelect?.errors?.['categoryMaxReached']">{{ 'total_goals_per_category_is_reached' | label : 'goals' | async }}</div>
      </div>

      <!-- weight -->
      <div class="col-md-6" *ngIf="showWeight">
        <label for="weight" class="form-label">{{ 'weight' | label : 'goals' | async }} <ng-container *ngIf="objectiveSingleton.settings.weightMandatory">*</ng-container></label>
        <div class="input-group">
          <input #weight="ngModel" type="text" name="weight" id="weight" appDigitOnly inputmode="numeric" pattern="[0-9]*" maxlength="6" [decimal]="true" class="form-control" [(ngModel)]="mutableObjective.weight" [required]="requiredWeight" (ngModelChange)="weightValidator(weight.control, mutableObjective)" />
          <span class="input-group-text">%</span>
          {{ weightValidator(weight.control, mutableObjective) }}
        </div>
        <!--Weight for this category has been reached-->
        <div class="text-danger" *ngIf="weight.errors?.['tooMuchWeight']">{{ 'total_weight_per_category_is_reached' | label : 'goals' | async }}</div>
      </div>
      <!-- due date -->
      <div class="col-md-6">
        <app-datepicker [date]="mutableObjective.dueDate" (dateChange)="mutableObjective.dueDate = $event" [label]="'due_date' | label : 'goals' | async" [inline]="false" [simple]="false" [marginBottom]="false"></app-datepicker>
      </div>

      <div *ngIf="objectiveSingleton.settings.allowAttachment" class="col-12"><hr /></div>

      <div class="col-6" *ngIf="objectiveSingleton.settings.allowAttachment">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="form-label" style="margin-right: 15px">
                {{ 'message_attachments' | label : 'homepage' | async }}
              </label>
              <button class="btn btn-sm" type="button" (click)="fileInput.click()">
                <span>+ {{ 'attachment' | label : 'conversations' | async }}</span>
                <input #fileInput type="file" ngFileSelect [options]="options" multiple (uploadOutput)="onUpload($event, mutableObjective)" style="display: none" />
              </button>
            </div>
          </div>
        </div>

        <!-- Attachment List -->
        <div class="mb-3">
          <ng-container *ngIf="mutableObjective.attachments && mutableObjective.attachments.length > 0">
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let attachment of mutableObjective.attachments; index as attachmentIndex">
                <span class="download-attachment cursor-pointer"> {{ attachment.fileName }}<i class="fa fa-fw fa-paperclip fs-6 primary-icon"></i> </span>
                <div class="d-flex align-items-center">
                  <a *ngIf="attachment.canDelete" class="text-danger cursor-pointer" (click)="deletePerformanceObjectiveAttachment(attachment.objectiveAttachmentId, mutableObjective)" ngbTooltip="{{ 'delete' | label : 'general' | async }}" placement="top" container="body">
                    <i class="far fa-fw fa-trash-alt fs-5"></i>
                  </a>
                </div>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>

      <div class="col-12"><hr class="" /></div>
      <!-- description -->
      <div class="col-12">
        <label for="description" class="form-label">{{ 'description' | label : 'goals' | async }}</label>
        <textarea name="description" id="description" class="form-control" [(ngModel)]="mutableObjective.description" rows="5" [style.resize]="'none'"></textarea>
      </div>
      <!-- kpi -->
      <div class="col-12" *ngIf="objectiveSingleton.settings.hasKPI">
        <label for="kPI" class="form-label">{{ 'kpi' | label : 'goals' | async }}</label>
        <textarea name="kPI" id="kPI" class="form-control" [(ngModel)]="mutableObjective.kpi" rows="5" [style.resize]="'none'"></textarea>
      </div>
      <!-- linkable -->
      <div class="col-md-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="mutableObjective.allowEmpLinking" name="allowEmpLinking" id="allowEmpLinking" />
          <label class="form-check-label" for="allowEmpLinking">{{ 'allow_linking' | label : 'goals' | async }}</label>
        </div>
      </div>
    </div>
  </div>
</form>
